export const projectLinks = [
    'https://github.com/NikhailKazak/COMP4900E_Project',
  ];
  